import Request from '../Request';
import EndPoints from '../EndPoints';
import Methods from '../Methods';
/**
 * Get all transmission modes
 * @param blockUI boolean
 * @return {Promise<any>}
 */
export default (function (blockUI) {
    if (blockUI === void 0) { blockUI = false; }
    var request = new Request({
        method: Methods.GET,
        url: EndPoints.REFERENCE_DATA_TRANSMISSION_MODES,
        withCredentials: true,
        blockUI: blockUI
    });
    return request.execute();
});
